"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeGeodesic = void 0;
const tslib_1 = require("tslib");
// @ts-ignore
const geographiclib_1 = tslib_1.__importDefault(require("geographiclib"));
const unit_1 = require("../unit");
const geoidModel = geographiclib_1.default.Geodesic.WGS84;
/** Utility to provide geospatial operations. */
exports.IkeGeodesic = {
    /**
     * Calculate the absolute distance between two locations.
     *
     * @returns Distance in meters.
     */
    getDistance(source, target) {
        // @ts-ignore
        const result = geoidModel.Inverse(source.latitude, source.longitude, target.latitude, target.longitude);
        return Math.abs(result.s12);
    },
    /** Calculate the vector from one location to another. */
    getVector(source, target) {
        // @ts-ignore
        const result = geoidModel.Inverse(source.latitude, source.longitude, target.latitude, target.longitude);
        const distance = result.s12;
        const bearing = unit_1.IkeAngle.normalize(unit_1.IkeAngle.toRadians(result.azi1));
        const pitch = 0; // Not implemented until needed
        return { distance, bearing, pitch };
    },
    /**
     * Move a location by a vector.
     *
     * @param source Original location.
     * @param bearing Bearing in radians.
     * @param distance Distance in meters.
     */
    projectLocation(source, bearing, distance) {
        const bearingDegrees = unit_1.IkeAngle.toDegrees(bearing);
        // @ts-ignore
        const result = geoidModel.Direct(source.latitude, source.longitude, bearingDegrees, distance);
        return {
            altitude: source.altitude,
            longitude: result.lon2,
            latitude: result.lat2
        };
    },
    /**
     * Find the center of a set of locations
     *
     * @param locations An array of locations to find the center of
     * @returns The center of the locations
     */
    findCenter(locations) {
        let sumLat = 0;
        let sumLng = 0;
        let subAlt = 0;
        for (let coordinate of locations) {
            sumLat += coordinate.latitude;
            sumLng += coordinate.longitude;
            subAlt += coordinate.altitude;
        }
        return {
            latitude: sumLat / locations.length,
            longitude: sumLng / locations.length,
            altitude: subAlt / locations.length
        };
    }
};
//# sourceMappingURL=geodesic.js.map